/**
 * Normalizes Greek text for search purposes.
 * Specifically handles the sigma variations (Σ, σ, ς) as the same character.
 * Optionally handles accents/tones if needed in the future.
 * 
 * @param {string} text - The text to normalize
 * @returns {string} - The normalized text
 */
export const normalizeGreekSearch = (text) => {
  if (!text) return '';
  return text
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[ςσ]/g, 'σ') // Map both lowercase sigmas to the medial sigma 'σ'
    .normalize('NFD') // Decompose combined characters (like ά to α + tone)
    .replace(/[\u0300-\u036f]/g, ''); // Remove the tone markers
};
